export function requestLinks(params, user) {
	return {
		type: '@clientMaquinaVirtual/REQUEST_LINKS',
		payload: { params, user },
	};
}

export function successLinks(dados) {
	return {
		type: '@clientMaquinaVirtual/SUCCESS_LINKS',
		payload: { dados },
	};
}

export function failureLinks(error) {
	return {
		type: '@clientMaquinaVirtual/FAILURE_LINKS',
		payload: { error },
	};
}

export function requestGerarLink(body, user) {
	return {
		type: '@clientMaquinaVirtual/REQUEST_GERAR_LINK',
		payload: { body, user },
	};
}

export function successGerarLink(dados) {
	return {
		type: '@clientMaquinaVirtual/SUCCESS_GERAR_LINK',
		payload: { dados },
	};
}

export function failureGerarLink(error) {
	return {
		type: '@clientMaquinaVirtual/FAILURE_GERAR_LINK',
		payload: { error },
	};
}

export function clearLink() {
	return {
		type: '@clientMaquinaVirtual/LIMPAR_LINK',
		payload: {},
	};
}

export function requestGerarLinkMassa(body, user) {
	return {
		type: '@clientMaquinaVirtual/REQUEST_GERAR_LINK_MASSA',
		payload: { body, user },
	};
}

export function successGerarLinkMassa(lista) {
	return {
		type: '@clientMaquinaVirtual/SUCCESS_GERAR_LINK_MASSA',
		payload: { lista },
	};
}

export function failureGerarLinkMassa(error) {
	return {
		type: '@clientMaquinaVirtual/FAILURE_GERAR_LINK_MASSA',
		payload: { error },
	};
}

export function requestDetalheLink(id) {
	return {
		type: '@clientMaquinaVirtual/REQUEST_DETALHE_LINK',
		payload: { id },
	};
}
